import { apiPaths } from 'configs/apiConfigs'
import useSWR from 'swr'

import { getBatchStatus } from './autoCheckApi'

export const useCheckBatchStatus = () => {
  const { data, error } = useSWR(apiPaths.checkBatchStatus(), getBatchStatus, {
    revalidateOnFocus: true,
    revalidateIfStale: true,
  })
  return { data, error }
}
